<template>
    <div class="popup" v-cloak v-if="signInShow" >
        <div class="content login-popup" id="signInPopup" :class="getPopupClass()" element-loading-background="rgba(0, 0, 0, 0.1)" @click.stop="" v-if="state=='signIn'||state=='signUp'||state=='forgetPwd'">
            <div class="title" style="background:white;height: 30px;border-radius: 10px;">
                <div class="title-back" v-if="state=='forgetPwd'" @click="backSignIn()">
                    <div class="icon-util arrow-left-blue" ></div>
                    <span class="alink">{{$t('language.cloudExploer.back')}}</span>
                </div>
                <div class="icon-popup-close" @click="closeDialog"></div>
            </div>
            <div v-if="!forgotPasswordShow">
                <div class="popup-body">
                    <!-- 登录页面 -->
                    <div class="page-body">
                        <div v-if="state=='signIn'">
                            <div class="logo"></div>
                            <h2 class="sign-title" v-if="!isTransfer">{{$t('language.login.title')}}</h2>
                            <h2 class="sign-title" v-else>{{$t('language.shareTransfers.signTitleByTransfer')}}</h2>
                            <hr class="sign-top-line">
                            <div class="font14" style="margin-bottom:17px;">{{$t('language.login.tips2')}}
                                <span class="alink" @click="toSignUp()" v-ga="{eventAction:'click',eventCategory:'/sign.html',eventLabel:'/share-pop'}">{{$t('language.login.signUp')}}</span>
                            </div>
                            <div class="mc-row">
                                <label for="" class="ic-label ic-email" :class="inputClass(selectInput.email)">
                                    <input type="text" name="email" class="width100" :placeholder="$t('language.login.logEmailInput')" autoComplete="off" v-model="email"
                                            :class="inputClass(selectInput.email)"
                                            @focus="focusInput('email')" @blur="testEmail()">
                                </label>
                                <p class="tips-info" :class="tipsClass(selectInput.email)">{{tipsMsg.email}}</p>
                            </div>
                            <div class="mc-row">
                                <label for="" class="ic-label ic-password" :class="inputClass(selectInput.password)">
                                    <input type="password" name="password" class="width100" autocomplete="new-password" :placeholder="$t('language.login.password')" v-model="password"
                                        :class="inputClass(selectInput.password)" ref="passwordLogin"
                                        @focus="focusInput('password')" @blur="testPassword()">
                                    <div class="password-eye" :class="showPassword?'icon-eye':'icon-eye-hide'" @click="checkShowPassword()"></div>
                                </label>
                                <p class="tips-info" :class="tipsClass(selectInput.password)">{{tipsMsg.password}}</p>
                            </div>
                            <div class="turnstile-container" ref="turnstileContainer"></div>
                            <div class="mc-row" v-if="forget">
                                <label for="" class="ic-label ic-verification f-dib width68" :class="inputClass(selectInput.code)">
                                    <input type="text" name="verificationCode" :placeholder="$t('language.login.verificationCode')" class="width100" id="signUpCode" v-model="code"
                                        :class="inputClass(selectInput.code)"
                                        @focus="focusInput('code')" @blur="testCode()">
                                </label>
                                <div class="f-dib"><img class="sign-verificationCode" @click.stop="refreshAndClearCode()" :src="ficationCode"></div>
                                <p class="err tips-info" :class="tipsClass(selectInput.code)">{{tipsMsg.code}}</p>
                            </div>
                            <div class="mc-row remember-forget-pass" style="margin-bottom:20px;padding-top: 10px;">
                                <div class="remember-check" @click="clickRemenberPass()">
                                    <div class="icon-check" :class="remenberPass?'':'icon-check-none'"></div>
                                </div>
                                <div class="remember-me">{{$t('language.login.keepLogin')}}</div>
                                <div class="alink" style="float: right;color: #282CB1;" @click="goToForgotPwd()">{{$t('language.login.forgotPassword')}}</div>
                            </div>
                            <div class="mc-row btn" style="margin-bottom:20px;">
                                <p class="err tips-info" :class="tipsClass(selectInput.btn)" style="position: absolute;top:-21px;">{{tipsMsg.btn}}</p>
                                <button @click="login()" class="login-btn" :class="loading?'no-click':''">
                                    <span v-if="loading">{{$t('language.login.btnTxt')}}</span>
                                    <span v-else>{{$t('language.login.logInButton')}}</span>
                                </button>
                            </div>
                            <div class="login-thirdLogin">
                                <p class="thirdLogin-tip"><span>{{$t('language.login.continueWith')}}</span></p>
                                <div class="thirdLogin">
                                    <button class="thirdLogin-btn" @click="thirdLogin('google_drive')" style="float:left;">
                                        <span class="sign-third-logo sign-google"></span>
                                    </button>
                                    <button class="thirdLogin-btn" @click="thirdLogin('apple')">
                                        <span class="sign-third-logo sign-apple"></span>
                                    </button>
                                    <button class="thirdLogin-btn" @click="thirdLogin('facebook')" style="float:right;">
                                        <span class="sign-third-logo sign-facebook"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 注册页面 -->
                    <div class="page-body" v-if="state=='signUp'">
                        <signUpDialog ref="signUpDialog" :isTransfer="isTransfer"></signUpDialog>
                    </div>
                    <!-- 忘记密码页面 -->
                    <div class="page-body" v-if="state=='forgetPwd'">
                        <forgetPwdDialog ref="forgetPwdDialog"></forgetPwdDialog>
                    </div>
                </div>
            </div>
        </div>
        <messages ref="messages"></messages>
        <!-- 多重验证相关页面 -->
        <div class="content" id="verify" v-loading="loading" :style="state=='recovery-success'?'height: 480px;':''"  element-loading-background="rgba(0, 0, 0, 0.1)" @click.stop="" v-if="state!='signIn'&&state!='signUp'&&state!='forgetPwd'">
            <div class="title" style="background:white;height: 30px;/*no*/">
                <div class="icon black-close dialog-close" @click="closeDialog()"></div>
            </div>
            <div v-if="state=='verify'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.verifyTitle')}}
                        <div class="ic-back" @click="state=recoveryPending?'recovery-pending':backState"></div>
                    </h2>
                </div>
                <div class="verify-body" >
                    <div class="verify-choice-body">
                        <button class="login-btn" v-if="vEmail" @click="choiceVerifyMethod('email')"><div class="verify-email" style="position: inherit;"></div>{{$t('language.login.email')+"  "+vEmail}}</button>
                        <button class="login-btn" v-if="vPhone" @click="choiceVerifyMethod('phone')"><div class="verify-phone" style="position: inherit;"></div>{{"Text  "+vPhone}}</button>
                    </div>
                    <div style="text-align: center;">
                        <a href="javascript:void(0)" style="text-decoration: inherit;" @click="state=recoveryPending?'recovery-cancel-error':'verify-recovery'">{{$t('language.popup.verifyPopup.toRecoveryText')}}</a>
                    </div>
                </div>
            </div>
            <div v-if="state=='verify-email'||state=='verify-phone'">
                <div class="verify-title">
                    <h2 v-if="choiceVerify=='email'">{{$t('language.popup.verifyPopup.verifyEmailTitle')}}
                        <div class="ic-back" @click="state='verify'"></div>
                    </h2>
                    <h2 v-if="choiceVerify=='phone'">{{$t('language.popup.verifyPopup.verifyPhoneTitle')}}
                        <div class="ic-back" @click="state='verify'"></div>
                    </h2>
                </div>
                <div class="verify-body" >
                    <div v-if="choiceVerify=='email'">
                        <p>{{$t('language.popup.verifyPopup.verifyEmailTips',{'email':vEmail})}}</p>
                        <div class="sign-line">
                            <div class="sign-input">
                                <input type="text" name="verifyEmail" v-model="verifyEmail" :placeholder="'someone@example.com'" class="signInInfo" />
                                <div class="verify-email-grow"></div>
                            </div>
                        </div>
                        <button :class="loading?'btn-not-allowed':''" class="sene-code-btn login-btn" @click="sendVerifyCodeByEmail()">{{$t('language.popup.verifyPopup.sendCodeBtn')}}</button>
                    </div>
                    <div v-if="choiceVerify=='phone'">
                        <p>{{$t('language.popup.verifyPopup.verifyPhoneTips',{'phone':vPhone,'last':vPhone.substring(vPhone.length-2, vPhone.length)})}}</p>
                        <div class="sign-line">
                            <div class="sign-input">
                                <input type="text" name="verifyPhone" v-model="verifyPhone" :placeholder="$t('language.popup.verifyPopup.verifyPhoneText')" class="signInInfo" maxlength="4"/>
                                <div class="verify-phone-grow"></div>
                            </div>
                        </div>
                        <button :class="loading?'btn-not-allowed':''" class="sene-code-btn login-btn" @click="sendVerifyCodeByPhone()">{{$t('language.popup.verifyPopup.sendCodeBtn')}}</button>
                    </div>
                </div>
            </div>
            <div v-if="state=='verify-code'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.verifyEmailTitle')}}
                        <div class="ic-back" @click="state='verify-'+choiceVerify;verifyCode=''"></div>
                    </h2>
                </div>
                <div class="verify-body" >
                    <p v-if="choiceVerify=='email'">{{$t('language.popup.verifyPopup.checkEmailTips',{'email':vEmail})}}</p>
                    <p v-if="choiceVerify=='phone'">{{$t('language.popup.verifyPopup.checkPhoneTips',{'phone':vtPhone.substring(vtPhone.length-4,vtPhone.length)})}}</p>
                    <div class="sign-line">
                        <div class="sign-input">
                            <input type="text" name="verifyCode" v-model="verifyCode" :placeholder="$t('language.login.verificationCode')" class="signInInfo" style="text-indent: 0px;" maxlength="6"/>
                        </div>
                    </div>
                    <div class="ask-device">
                        <div v-if="!recoveryPending" class="icon-util" :class="askDevice?'check-small':'nocheck-small'" @click="clickAskDevice()"></div>
                        <div v-if="!recoveryPending">{{$t('language.popup.verifyPopup.askDevice')}}</div>
                        <button ckass="login-btn" :class="loading?'btn-not-allowed':''" @click="verificationCode()">{{$t('language.popup.verifyPopup.verify')}}</button>
                    </div>
                </div>
            </div>
            <div v-if="state=='verify-recovery'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryTitile')}}
                        <div class="ic-back" @click="state='verify'"></div>
                    </h2>
                </div>
                <div class="verify-body" >
                    <p style="margin-top: 5%;">{{$t('language.popup.verifyPopup.recoveryTipsOne')}}</p>
                    <p style="margin-top: 5%;">{{$t('language.popup.verifyPopup.recoveryTipsTwo')}}</p>
                    <div class="sign-line">
                        <div class="sign-input">
                            <input type="text" name="verifyRecoveryCode" v-model="verifyRecoveryCode" :placeholder="$t('language.popup.verifyPopup.recoveryCode')" class="signInInfo" style="text-indent: 0px;"/>
                        </div>
                    </div>
                    <button :class="loading?'btn-not-allowed':''" class="sene-code-btn login-btn" @click="verificationRecoveryCode()">{{$t('language.popup.verifyPopup.recoveryCodeBtn')}}</button>
                </div>
            </div>
            <div v-if="state=='recovery-change'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryChangeTitile')}}
                        <div class="ic-back" @click="state='verify-recovery'"></div>
                    </h2>
                </div>
                <div class="verify-body" style="margin-top: 70px;">
                    <cloud-select ref="cloudSelect"  @changeOption="onChangeOption()" :widthVal="300"
                        :selectOption="selectOption" :placeholder="selectValue" style="margin:0 !important;float:left"></cloud-select>
                    <cloud-select ref="phoneSelect" @deleteSelectOption="showOtherOptions()"  v-if="choiceVerify=='phone'"  @changeOption="onChangePhoneOption()" :widthVal="300"
				        :selectOption="selectPhoneOption" :placeholder="selectPhoneValue" style="margin:0 !important;float:left"></cloud-select>
                    <input type="text" style="width:100%;marginBottom:10Px;" v-if="choiceVerify=='email'" :placeholder="$t('language.popup.verifyPopup.enterEmail')" class="ftp-cont-right-one"  v-model="verifyEmail">
                    <input type="text" style="width:100%;marginBottom:10Px;" v-if="choiceVerify=='phone'" :placeholder="$t('language.popup.verifyPopup.codeText')" class="ftp-cont-right-one"  v-model="verifyPhone">
                    <button :class="loading?'btn-not-allowed':''" class="sene-code-btn login-btn" @click="sendVerifyByRecovery()">{{$t('language.popup.reportPopup.next')}}</button>
                </div>
            </div>
            <div v-if="state=='recovery-verify-code'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryNextTitle',{"checkCode":choiceVerify=='email'?verifyEmail:verifyPhone})}}
                        <div class="ic-back" @click="state='recovery-change';verifyCode=''"></div>
                    </h2>
                </div>
                <div class="verify-body" style="margin-top: 70px;">
                    <div class="sign-line">
                        <div class="sign-input">
                            <input type="text" name="verifyCode" v-model="verifyCode" :placeholder="$t('language.login.verificationCode')" class="signInInfo" style="text-indent: 0px;" maxlength="6"/>
                        </div>
                    </div>
                    <button :class="loading?'btn-not-allowed':''" class="sene-code-btn login-btn" @click="verificationCode()">{{$t('language.popup.reportPopup.next')}}</button>
                </div>
            </div>
            <div v-if="state=='recovery-success'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryTipsTitle')}}</h2>
                </div>
                <div class="verify-body recovery-success">
                    <p style="color: #D6D6D6;">{{$t('language.popup.verifyPopup.recoveryTips1')}}</p>
                    <p style="color: #D6D6D6;">{{$t('language.popup.verifyPopup.recoveryTips2')}}</p>
                    <div style="margin-top: 5%;">
                        <p style="font-weight: 700;">{{$t('language.popup.verifyPopup.recoveryTips3')}}</p>
                        <p><span style="font-weight: 700;">{{$t('language.popup.verifyPopup.recoveryTips4')}}</span>{{$t('language.popup.verifyPopup.recoveryTips5')}}</p>
                        <p><span style="font-weight: 700;">{{$t('language.popup.verifyPopup.recoveryTips6')}}</span>{{$t('language.popup.verifyPopup.recoveryTips7')}}</p>
                        <p>{{$t('language.popup.verifyPopup.recoveryTips8')}}</p>
                    </div>
                    <button class="sene-code-btn login-btn" style="margin-top: 15px;" @click="state='signIn'">{{$t('language.popup.reportPopup.next')}}</button>
                </div>
            </div>
            <div v-if="state=='recovery-pending'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryPendTitle')}}
                        <div class="ic-back" @click="state=backState"></div>
                    </h2>
                </div>
                <div class="verify-body recovery-success">
                    <p style="color: #D6D6D6;">{{$t('language.popup.verifyPopup.recoveryPendTips1',{"data":pendData})}}</p>
                    <div style="margin-top: 5%;">
                        <p style="font-weight: 700;">{{$t('language.popup.verifyPopup.recoveryPendTips2')}}</p>
                        <p v-if="vEmail">{{$t('language.popup.verifyPopup.recoveryPendTips3')+vEmail}}</p>
                        <p v-if="vPhone">{{$t('language.popup.verifyPopup.recoveryPendTips4')+vPhone}}</p>
                        <div style="margin-top: 5%;">
                            <p style="font-weight: 700;">{{$t('language.popup.verifyPopup.recoveryPendTips5')}}</p>
                            <p v-if="pendEmail">{{$t('language.popup.verifyPopup.recoveryPendTips3')+pendEmail}}</p>
                            <p v-if="pendPhone">{{$t('language.popup.verifyPopup.recoveryPendTips4')+pendPhone}}</p>
                        </div>
                        <div style="margin-top: 5%;">
                            <p>
                                {{$t('language.popup.verifyPopup.recoveryPendTips6')}}
                                <a href="javascript:void(0);" @click="cancelVerify()" style="text-decoration: inherit;">{{$t('language.popup.verifyPopup.recoveryPendTips7')}}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="state=='recovery-cancel'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryCancelTitle')}}</h2>
                </div>
                <div class="verify-body recovery-success">
                    <p style="color: #D6D6D6;">{{$t('language.popup.verifyPopup.recoveryCancelTips1')}}</p>
                    <p style="color: #D6D6D6;">{{$t('language.popup.verifyPopup.recoveryCancelTips2')}}</p>
                    <p style="color: #D6D6D6;">{{$t('language.popup.verifyPopup.recoveryCancelTips3')}}</p>
                    <div style="margin-top: 5%;">
                        <p>{{$t('language.popup.verifyPopup.recoveryCancelTips4')}}</p>
                        <p style="font-weight: 700;">{{newRecoveryCode}}</p>
                    </div>
                    <button class="sene-code-btn login-btn" style="margin-top: 15px;" @click="state='recovery-cancel-success'">{{$t('language.popup.reportPopup.next')}}</button>
                </div>
            </div>
            <div v-if="state=='recovery-cancel-success'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryCancelSucTitle')}}</h2>
                </div>
                <div class="verify-body recovery-success">
                    <p>{{$t('language.popup.verifyPopup.recoveryCancelSucTips1',{"old":email})}}</p>
                    <p>{{$t('language.popup.verifyPopup.recoveryCancelSucTips2',{"new":dual.pendingVerifyDevice})}}</p>
                    <div style="margin-top: 5%;">
                        <p>{{$t('language.popup.verifyPopup.recoveryCancelSucTips3')}}</p>
                    </div>
                    <button class="sene-code-btn login-btn" style="margin-top: 15px;" @click="state='signIn'">{{$t('language.popup.reportPopup.next')}}</button>
                </div>
            </div>
            <div v-if="state=='recovery-cancel-error'">
                <div class="verify-title">
                    <h2>{{$t('language.popup.verifyPopup.recoveryCancelErrorTitle')}}</h2>
                </div>
                <div class="verify-body recovery-success">
                    <p style="color: red;margin-bottom:25%">{{$t('language.popup.verifyPopup.recoveryCancelErrorTips')}}</p>
                    <button class="sene-code-btn" style="margin-top: 15px;" @click="state='verify'">{{$t('language.popup.reportPopup.next')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import messages from '@/messages/message.vue';
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import "@/assets/css/common_util.css";
import "@/assets/css/file_type.css";
import "@/assets/css/drive_type.css";
import cloudSelect from "@/components/common/select/set_cloud_select";
import areaCodeUtil from "../../../js/workspace/area_code_utils.js";
import "@/assets/css/login_popup.css";
import loginUtil from "@/js/workspace/login_popup.js";
import signUpDialog from '@/components/popup/share_page_popups/sign_up_popup';
import forgetPwdDialog from '@/components/popup/share_page_popups/forget_pwd_popup';

const TURNSTILE_SCRIPT_ID = 'cloudflare-turnstile-script';
const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let turnstileScriptPromise = null;

function loadTurnstileScript() {
    if (window.turnstile) {
        return Promise.resolve(window.turnstile);
    }
    if (turnstileScriptPromise) {
        return turnstileScriptPromise;
    }

    turnstileScriptPromise = new Promise((resolve, reject) => {
        let script = document.getElementById(TURNSTILE_SCRIPT_ID);
        const onLoad = () => {
            if (!window.turnstile) {
                turnstileScriptPromise = null;
                reject(new Error('Turnstile API is unavailable'));
                return;
            }
            resolve(window.turnstile);
        };
        const onError = () => {
            turnstileScriptPromise = null;
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
            reject(new Error('Failed to load Turnstile API'));
        };

        if (script) {
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            return;
        }

        script = document.createElement('script');
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });
        document.head.appendChild(script);
    });
    return turnstileScriptPromise;
}

export default {
    props: ['isTransfer'],//判断是否是分享传输页面
    components: {
        messages: messages,
        "cloud-select": cloudSelect,
        signUpDialog,
        forgetPwdDialog,
    },
    data() {
        return {
            signInShow: false,
            remenberPass: true,
            ficationCode: '',
            user: "",
            email: "",
            password: "",
            signUpPassword: '',
            username: "",
            code: '',
            dis: false,
            ud: '',
            messageEmail: '',
            loading: false,
            forget: false,
            refresh: true,
            errorTime: 0,
            vkey: "",
            forgotPasswordShow: false,
            forgotEmail: "",
            forgotVerification: "",

            state: "signIn",//当前弹出框显示页面
            backState: "",//多重验证返回时需要返回的页面
            dualUd: "",//多重验证ud
            dual: {},//多重验证实体
            otp: "",//多重验证信任码
            dualOtp: "",//多重验证一次性信任码
            dualRember: false,
            vtEmail: "",
            vtPhone: "",
            vEmail: "",//*号替换
            vPhone: "",//*号替换
            verifyEmail: "",//输入的Email
            verifyPhone: "",//输入的PhoneNumber
            verifyCode: "",//输入的code
            verifyRecoveryCode: "",//输入的recovery code
            choiceVerify: "email",//选择的验证方式
            askDevice: true,//是否信任当前设备
            cornet: "",//区号
            selectOptionAll: [{
                name: this.$t('language.popup.verifyPopup.recoveryEmailChange'),
                icon: false,
                id: 0
            }, {
                name: this.$t('language.popup.verifyPopup.recoveryPhoneChange'),
                icon: false,
                id: 1
            }],//选择验证方式
            selectValue: this.$t('language.popup.verifyPopup.recoveryEmailChange'),
            selectOption:[{
				name: this.$t('language.popup.verifyPopup.recoveryPhoneChange'),
				icon: false,
				id: 1
			}],
            newRecoveryCode: "",//新recovery码
            recoveryPending: false,//当前账号是否是pending状态
            pendEmail: "",
            pendPhone: "",
            pendData: "",
            onChangePhoneAllOption:areaCodeUtil.areacode,
            selectPhoneOption:Object.assign([],areaCodeUtil.areacode),//可供选择的项
            selectPhoneValue:'United States(+1)',
            //新增页面信息
            selectInput: {//输入框状态
                email: "",
                password: "",
                code: "",
            },
            tipsMsg: {//错误提示
                email: "",
                password: "",
                code: "",
                btn: ""
            },
            showPassword: false,//是否显示密码
            signUpCode: false,//注册是否显示验证码
            turnstileToken: '',
            turnstileWidgetId: null,
            turnstileWaiting: false,
        };
    },
    created() {
        //this.$i18n.locale = 'english';
        // var that = this;
        // if (this.$cookies.get('email')) {
        //     this.email = Base64.decode(this.$cookies.get('email'));
        //     this.password = Base64.decode(this.$cookies.get('password'));
        //     this.remenberPass = true;
        // }
    },
    watch: {
        signInShow(val){
            if(this.signInShow){
                this.initPage();
                this.refreshAndClearCode();
                this.$nextTick(() => this.renderTurnstile());
            }else{
                this.removeTurnstile();
                if(!this.remenberPass){
                    this.email = ""
                    this.password = ""
                }
                this.signInShow = false;
                this.code = ""
            }
        },
        state(val, oldVal){
            if(!this.signInShow) return;
            if(val === 'signIn'){
                this.$nextTick(() => this.renderTurnstile());
            }else if(oldVal === 'signIn'){
                this.removeTurnstile();
            }
        },
        email(val){
            //改变邮箱名时，重置失败次数，是否需要验证码，密码，验证码
            this.password = ""
            this.errorTime = 0;
            this.forget = false;
            this.code = "";
        },
    },
    mounted() {
        window.addEventListener('message', this.loginCallback);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.loginCallback);
        this.removeTurnstile();
    },
    methods: {
        renderTurnstile(){
            if(!this.signInShow || this.state !== 'signIn') return;
            loadTurnstileScript().then(turnstile => {
                if(!this.signInShow || this.state !== 'signIn' || !this.$refs.turnstileContainer) return;
                if(this.turnstileWidgetId !== null){
                    return;
                }
                this.turnstileWidgetId = turnstile.render(this.$refs.turnstileContainer, {
                    sitekey: commonstate.turnstileSiteKey,
                    action: 'login',
                    size: 'flexible',
                    appearance: 'always',
                    theme: 'light',
                    callback: token => {
                        this.turnstileToken = token;
                    },
                    'expired-callback': () => {
                        this.resetTurnstile();
                    },
                    'timeout-callback': () => {
                        this.resetTurnstile();
                    },
                    'error-callback': () => {
                        this.turnstileToken = '';
                    }
                });
            }).catch(error => {
                this.turnstileToken = '';
                console.warn('Turnstile initialization failed:', error.message);
            });
        },
        resetTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.reset(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile reset failed:', error.message);
                }
            }
        },
        removeTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.remove(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile removal failed:', error.message);
                }
            }
            this.turnstileWidgetId = null;
        },
        waitForTurnstileToken(timeout){
            const maxWait = timeout || 5000;
            const startedAt = Date.now();
            return new Promise(resolve => {
                const checkToken = () => {
                    if(this.turnstileToken || !this.signInShow || Date.now() - startedAt >= maxWait){
                        resolve(this.turnstileToken);
                        return;
                    }
                    setTimeout(checkToken, 100);
                };
                checkToken();
            });
        },
        resumeLoginAfterDualVerify(){
            this.state = 'signIn';
            this.$nextTick(() => {
                this.renderTurnstile();
                this.waitForTurnstileToken(5000).then(() => {
                    if(this.signInShow && this.state === 'signIn'){
                        this.login(true);
                    }
                });
            });
        },
        //初始化页面
        initPage(){
            this.selectInput = {
                email: "normal",
                password: "normal",
                code: "normal",
            },
            this.email = "",
            this.password = "",
            this.code = "",
            this.tipsMsg = {
                email: "",
                password: "",
                code: "",
                btn: ""
            };
        },
        toSignUp(){
            if(!this.remenberPass){
                this.email = ""
                this.password = ""
            }
            this.code = ""
            this.state='signUp';
        },
        inputClass(type){
            return loginUtil.inputClass(type);
        },
        tipsClass(type){
            return loginUtil.tipsClass(type);
        },
        getPopupClass(){
            var cla = "sign-in-popup";
            switch (this.state) {
                case "signUp":
                    cla = "sign-up-popup"
                    if(this.signUpCode) {
                        cla = "sign-up-code";
                    }
                    break;
                case "forgetPwd":
                    cla = "forget-pwd-popup"
                    break;
                case "signIn":
                    cla = "sign-in-popup";
                    if(this.forget){
                        cla = "sign-in-code";
                    }  
                    break;
                default:
                    break;
            }
            return cla;
        },
        //获取焦点后清除提示
        focusInput(type){
            loginUtil.focusInput(this,type);
        },
        /* 检查格式 */
        testEmail(){
            if (this.email == "") {
                this.selectInput.email = "error";
                this.tipsMsg.email = this.$t('language.login.exception.strEmpty');
            }else{
                this.selectInput.email = "normal";
                this.tipsMsg.email = "";
            }
            // loginUtil.testEmail(this);
        },
        testPassword(){
            loginUtil.testPassword(this);
        },
        testCode(){
            loginUtil.testCode(this);
        },
        //跳转到老版忘记密码页面
        goToOldForgotPassword(){
          window.open(commonstate.nowNewUrl+"/sign#forget");
        },
        backSignIn(){
            this.state = "signIn";
        },
        //跳转到老版忘记密码页面
        goToForgotPwd(){
          this.state = "forgetPwd";
        },
        emailVerification() {
            let myReg = commonstate.emailpattern;
            if (!myReg.test(this.forgotEmail) && this.forgotEmail) {
                this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: "signInPopup"
                });
                return false;
            }else{
                return true
            }
        },
        // sendForgetPassCode() {
        //     window.open("https://www.multcloud.com/forgot_password")
        // },
        login(skipTurnstileWait) {
            let that = this;
            //校验参数
            this.testEmail();
            this.testPassword();
            if(this.selectInput.email=="error") return;
            if(this.selectInput.password=="error") return;
            if(this.loading) return;
            if(!this.turnstileToken && !skipTurnstileWait){
                if(this.turnstileWaiting) return;
                this.turnstileWaiting = true;
                this.waitForTurnstileToken(3000).then(() => {
                    this.turnstileWaiting = false;
                    if(this.signInShow && this.state === 'signIn'){
                        this.login(true);
                    }
                });
                return;
            }
            var loginData = {
                email: this.email,
                password: this.password.replace(/^\s*|\s*$/g, ""),
                language: commonUtils.getLocaleTo(localStorage.getItem("locale")),
            }
            if(this.turnstileToken){
                loginData.turnstileToken = this.turnstileToken;
            }
            if(this.forget && !this.dualOtp){
                if(!this.code){
                    this.selectInput.code = "error";
                    this.tipsMsg.code = this.$t('language.login.enterCode');
                    return;
                }
                this.testCode();
                if(this.selectInput.code=="error") return;
                loginData.vcode = this.code;
                loginData.vkey = this.vkey;
            }
            if (this.remenberPass) {
                //记住账号
                loginData.rememberMe = true;
            }else{
                //不记住账号，只保存2个小时
                loginData.rememberMe = false;
            }
            //如果当前已存在唯一验证码，则添加多重验证唯一验证码
            if(this.dualOtp){
                if(!this.dualRember){
                    loginData.rememberMe = false;
                }
                loginData.otp = this.dualOtp;
                this.dualOtp = "";
            }
            var tdJson = localStorage.getItem("trustedDevice");
            if(tdJson){

                var td = commonUtils.getTrustedDeviceByEmail(loginData.email);
                if(td){
                    loginData.tdcode = td;
                }
            }
            this.resetVerifyAttribute();
            this.loading=true;
            //将用户成功登录后的信息存在localStorage中
            this.Utils.doUserRequest("sign_in_", loginData)
                .then(response => {
                    if (response.status == 200) {
                        this.user = response.user;
						
                        //获取当前时间
                        var nData = new Date().getTime();
                        //过期时间
                        var eData;
                        if (this.remenberPass) {
                            let Base64 = require('js-base64').Base64;
                            this.$cookies.set("email", Base64.encode(this.email), "1y");
                            this.$cookies.set("password", Base64.encode(this.password), "1y");
                            eData = nData + 24 * 60 * 60 * 7 *1000;//+7天
                            localStorage.setItem('expirationTime', eData);
                        }else{
                            //不储存user
                            eData = nData + 2 * 60 * 60 *1000;//+2小时
                            localStorage.setItem('expirationTime', eData);
                        }
                        commonUtils.setUserToLocal(this.user);
                        location.reload();
                        that.$store.commit('setleftbannerClick', -1);
                        that.$store.commit('setleftbannerMenuClick', 106);
                        // this.loading=false;
                    } else {
                        this.loading=false;
                        this.resetTurnstile();
                        if(response.status != 200&&this.forget){//刷新验证码
                            this.selectInput.btn = "error";
                            this.refreshAndClearCode();
                        }
                        if(response.status=="401"&&response.reason=="notAuthorized"){
                            this.errorTime += 1 
                            this.tipsMsg.btn = this.$t('language.login.enterCorrectPass');
                            if(this.errorTime>4){//如果同意页面连续输错超过4次，则直接显示验证码
                                this.forget = true;
                            }
                        }else
                        if(response.status=="403"&&response.reason=="verifyCodeInvalid"){
                            if(this.forget){//验证码错误，提示报错
                                this.selectInput.code = "error";
                                this.tipsMsg.code = this.$t('language.login.verificationIncorrect');
                            }else{//如果是需要验证码，则不提示报错
                                this.forget = true;
                            }
                        }else
                        if(response.status=="403"&&response.reason=="exceedMaxLimit"){
                            this.tipsMsg.btn = this.$t('language.sharesPage.loginErrorMax');
                        }else 
                        if (response.status=="403"&&response.reason == "notSupportedRegion") {
                            let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
                            let link = commonstate.frontEndUrl+(language=="en"?"":"/"+language)+'/region-not-supported.html';
                            window.location.href = link;
                        }else 
                        if (response.status=="400"&&response.exception == "unauthorizedEquipment") {
                            //进入多重验证
                            this.dual = response.dual;
                            this.dualUd = response.dual.userId;
                            this.otp = response.otp;
                            this.backState = "signIn";
                            this.getVerifyMessage("verify")
                        }else 
                        if(response.status=="400"&&response.exception == "pendingActivated") {
                            //进入修改验证进行中页面
                            this.dual = response.dual;
                            this.dualUd = response.dual.userId;
                            this.backState = "signIn";
                            this.getVerifyMessage("recovery-pending")
                        }else if(response.status=="404"&&response.reason == "userNotFound"){
                            this.selectInput.email = "error";
                            this.tipsMsg.email = this.$t('language.login.exception.emailPsdError');
                        }else{
                            this.selectInput.btn = "error";
                            this.tipsMsg.btn = response.msg;
                        }
                    }
                }, err => {
                    this.resetTurnstile();
                    this.selectInput.btn = "error";
                    this.tipsMsg.btn = err;
                    this.loading=false;
                });
        },
        thirdLogin(loginType) {
            var redirectUrl = commonstate.loginRedirectUrl;
            var url = commonstate.sharePageApiUrl + "/api/user/third_login?loginType=" + loginType + "&redirectUrl=" + redirectUrl;
            window.open(url, "newwindow", "height=600, width=600,toolbar=no,scrollbars=yes,menubar=no");
        },
        refreshAndClearCode() {
            let userEmail;
            if(this.forgotPasswordShow){
                userEmail = this.forgotEmail;
            }else{
                userEmail = this.email;
            }
            this.vkey = this.Utils.generateVerifyKey();
            this.Utils.doVerifyCodeRequest("generate", {
                params: {
                    email: userEmail //这里是请求接口书需要传的数据
                },
                responseType: 'arraybuffer', //这里是声明期望返回的数据类型
                vkey: this.vkey
            }).then(response => {
                return 'data:image/png;base64,' + btoa(new Uint8Array(response).reduce((data, email) => data + String.fromCharCode(email), ''));
            }).then(data => { //这一次箭头函数是依赖于第一次.then函数处理的data值
                this.ficationCode = data

            });
        },
        loginCallback(result) {
            if (result.data && result.data.length > 150) {
                //去掉两端引号
                let str = result.data;
                str = str.toString().replace(/(^\"*)|(\"*$)/g, "");
                let userInfo = this.Utils.decrypt(str);
                if (userInfo.user) {
                    commonUtils.setUserToLocal(userInfo.user);
                    location.reload()
                }

            }
        },
        closeDialog() {
            if(!this.remenberPass){
                this.email = ""
                this.password = ""
            }
            this.forget = false;
            this.signInShow = false;
            this.code = "";
            //忘记密码页面相关
            this.forgotPasswordShow = false;
            this.forgotEmail = "";
            this.forgotVerification = "";
            this.resetVerifyAttribute();
        },
        //重置多重验证相关属性
        resetVerifyAttribute(){
            //多重验证相关
            this.state = "signIn",//当前弹出框显示页面
            this.vtEmail = "";
            this.vtPhone = "";
            this.vEmail = "";//*号替换
            this.vPhone = "";//*号替换
            this.verifyEmail = "";//输入的Email
            this.verifyPhone = "";//输入的PhoneNumber
            this.verifyCode = "";//输入的code
            this.verifyRecoveryCode = "";//输入的recovery code
            this.choiceVerify = "email";//选择的验证方式
            this.askDevice = true;//是否信任当前设备
            this.cornet = "";//区号
            this.selectOptionAll = [{
                name: this.$t('language.popup.verifyPopup.recoveryEmailChange'),
                icon: false,
                id: 0
            }, {
                name: this.$t('language.popup.verifyPopup.recoveryPhoneChange'),
                icon: false,
                id: 1
            }];//选择验证方式
            this.selectValue = this.$t('language.popup.verifyPopup.recoveryEmailChange');
            this.selectOption = [{
				name: this.$t('language.popup.verifyPopup.recoveryPhoneChange'),
				icon: false,
				id: 1
			}];
            this.newRecoveryCode = "";//新recovery码
            this.recoveryPending = false;//当前账号是否是pending状态
            this.pendEmail = "";
            this.pendPhone = "";
        },
        openToSignUp() {
            window.open(commonstate.nowNewUrl+"/sign?source=share")
        },
        clickRemenberPass(){
            this.remenberPass = !this.remenberPass
        },
        //是否进入忘记密码页面
        changeForgotShow(){
            this.forgotPasswordShow = !this.forgotPasswordShow;
        },
        //发送忘记密码邮件（后台功能未完善）
        sendForgotEmail(){
            if (!this.forgotEmail) {
                this.$toast({
                    text: this.$t('language.login.pleaseEmail'),
                    type: 'fail',
                    idValue: "signInPopup"
                });
                return false;
            }else if(!this.emailVerification()){
                return false;
            }
            if (!this.forgotVerification) {
                this.$toast({
                    text: this.$t('language.login.enterCode'),
                    type: 'fail',
                    idValue: "signInPopup"
                });
                return false;
            }
            let forgotEmail = {
                ud: this.user.id,
                ck: this.vkey,
                code: this.forgotVerification,
                email: this.forgotEmail,
                workUrl: commonstate.nowNewUrl+"/reset.html?code=",
            }
            this.Utils.doEmailRequest("send_forgot_code", forgotEmail).then(res => {
            if (res.message === 'success'){
              this.$toast({
                text: this.$t('language.popup.cloudExploerPopup.emailSentSuccessful'),
                type: "success",
                idValue: "share"
              });
            }else{
              this.$toast({
                text: this.$t('language.popup.cloudExploerPopup.emailSentNotice'),
                type: "notice",
                idValue: "share"
              });
            }
          })
        },
        /*
        *   以下为多重验证相关方法
        */
        //获取多重验证信息并使用*号替换
        getVerifyMessage(state){
            // this.Utils.doDualVerifyAesRequest("get", {ud:this.dualUd}).then(res => {
            //     if(res.status=="on"){
                    //不受信任设备登录或修改验证中
                    this.pendData = this.format(this.dual.pendingExpiration-1000*60*60*24*30);
                    this.vtEmail = this.dual.email;
                    this.vtPhone = this.dual.smsPhone;
                    if(this.vtEmail != null){
                        this.vEmail = this.encryptionEmail(this.vtEmail);
                    }
                    if(this.vtPhone != null){
                        this.vPhone = this.encryptionPhone(this.vtPhone);
                    }
                    if(this.dual.pendingVerifyDevice){
                        let pend = this.dual.pendingVerifyDevice;
                        if(pend.indexOf('@')>0){
                            pend = this.encryptionEmail(pend)
                            this.pendEmail = pend;
                        }else{
                            pend = this.encryptionPhone(pend);
                            this.pendPhone = pend;
                        }
                    }
                    this.state = state;
                // }
            // })
        },
        encryptionEmail(email) {
            let index = email.indexOf('@');
            if(index > 2){
                email = email.substring(0,2)+"******"+email.substring(index, email.length);
            }else{
                email = "******"+email.substring(index, email.length);
            }
            return email;
        },
        encryptionPhone(phone) {
            phone = "******"+phone.substring(phone.length-2, phone.length);
            return phone;
        },
        //选择验证方式
        choiceVerifyMethod(state){
            this.choiceVerify = state;
            this.state = "verify-"+state;
        },
        //根据选择的验证方式发送验证码
        sendVerifyByRecovery(){
            switch (this.choiceVerify) {
                case "email":
                    this.sendVerifyCodeByEmail();
                    break;
                case "phone":
                    this.sendVerifyCodeByPhone();
                    break;
                default:
                    break;
            }
        },
        //根据选择的验证方式发送验证码
        sendVerifyCodeByEmail(){
            var email = this.verifyEmail;
            if(!email){return;}
            if(this.vEmail.substring(0,2)!=email.substring(0,2)&&this.state!="recovery-change"){
                //前两位不同报错 
                this.$toast({
                    text: this.$t('language.popup.verifyPopup.exception.emailLastTwoStringError',{"errorCode":this.vEmail.substring(0,2)}),
                    type: "notice",
                    idValue: "verify"
                });
                return;
            }

            //验证格式
            var emailRegex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
            if (!emailRegex.test(email) || email.length > 128) {
                this.$toast({
                    text: this.$t('language.popup.verifyPopup.exception.validEmail'),
                    type: "notice",
                    idValue: "verify"
                });
                return;
            }

            var data = {
                userId:this.dualUd,
                email:email,
            }
            this.loading=true;
            var link = "check_send";
            if(this.state=="recovery-change"){
                link = "send";
            }
            this.Utils.doDualVerifyAesRequest(link, data).then(res => {
                this.loading=false;
                if(res.status==200){
                    this.choiceVerify = "email";
                    if(this.state=="recovery-change"){
                        this.state = "recovery-verify-code"
                    }else{
                        this.state = "verify-code"
                    }
                }
            })
        },
        sendVerifyCodeByPhone(){
            var phone = this.verifyPhone;
            if(!phone){return;}
            if(this.vPhone.substring(this.vPhone.length-2,this.vPhone.length)!=phone.substring(phone.length-2,phone.length)&&this.state!="recovery-change"){
                //前两位不同报错 
                this.$toast({
                    text: this.$t('language.popup.verifyPopup.exception.phoneLastTwoStringError',{"errorCode":this.vPhone.substring(this.vPhone.length-2,this.vPhone.length)}),
                    type: "notice",
                    idValue: "verify"
                });
                return;
            }

            if(phone.length != 4&&this.state!="recovery-change"){
                //后四位不是四位字符报错 
                this.$toast({
                    text: this.$t('language.popup.verifyPopup.exception.validPhone'),
                    type: "notice",
                    idValue: "verify"
                });
                return;
            }
            if(this.state=="recovery-change"){
                var data = {
                    userId: this.dualUd,
                    cornet: this.cornet,
                    phoneNumber: phone
                }
                this.loading=true;
                this.Utils.doDualVerifyAesRequest("send", data).then(res => {
                    this.loading=false;
                    if(res.status==200){
                        this.choiceVerify = "phone";
                        this.state = "verify-code";
                        
                    }else if(res.status==400&&res.reason=="hour24Limit"){
                        //短信报错
                        this.$toast({
                            text: this.$t('language.twoStepverification.toManyCodeSend'),
                            type: "notice",
                            idValue: "verify"
                        });
                    }
                })
            }else{
                var data2 = {
                    userId: this.dualUd,
                    tail: phone
                }
                this.loading=true;
                this.Utils.doDualVerifyAesRequest("tail", data2).then(res => {
                    this.loading=false;
                    if(res.status==200){
                        this.choiceVerify = "phone";
                        if(this.state=="recovery-change"){
                            this.state = "recovery-verify-code"
                        }else{
                            this.state = "verify-code"
                        }
                    }else if(res.status==400&&res.reason=="hour24Limit"){
                        //短信报错
                        this.$toast({
                            text: this.$t('language.twoStepverification.toManyCodeSend'),
                            type: "notice",
                            idValue: "verify"
                        });
                    }
                })
            }
            // this.Utils.doDualVerifyAesRequest("cornet", {userId:this.dualUd}).then(request => {
            //     if(request.status==200){
            //         var data = {
            //             userId: this.dualUd,
            //             cornet: request.cornet,
            //             phone: phone
            //         }
            //         this.cornet = request.cornet;
            //         this.Utils.doDualVerifyAesRequest("check_send", data).then(res => {
            //             if(res.status==200){
            //                 this.choiceVerify = "phone",
            //                 this.state = "verify-code"
            //             }
            //         })
            //     }
            // })  
        },
        clickAskDevice(){
            this.askDevice = !this.askDevice;
        },
        //校验验证码
        verificationCode(){
            if(!this.verifyCode.trim()){
                this.$toast({
                    text: this.$t('language.popup.verifyPopup.exception.verificationCodeNull'),
                    type: "notice",
                    idValue: "verify"
                });
                return;
            }
            var data = {
                userId: this.dualUd,
                verificationCode: this.verifyCode.trim(),
            }
            switch (this.choiceVerify) {
                case "email":
                    data.email = this.verifyEmail;
                    break;
                case "phone":
                    const index = this.dual.smsPhone.indexOf('-');
                    data.cornet = this.dual.smsPhone.substring(0,index);
                    data.phoneNumber = this.dual.smsPhone.substring(index+1,this.dual.smsPhone.length);
                    break;
                default:
                    break;
            }
            this.loading=true;
            this.Utils.doDualVerifyAesRequest("verify", data).then(res => {
                if(res.status==200&&res.message){
                    if(this.state=="recovery-verify-code"){
                        //进入pending并发送邮件
                        this.changeRecoveryState(data);
                    }else if(this.recoveryPending){
                        //取消pending验证流程
                        //获取新的recovery码
                        this.closePending();
                    }else if(this.askDevice){
                        var td = this.generateUUID();
                        this.Utils.doDualVerifyAesRequest("trusted", {userId:this.dualUd,trustedDevice:td}).then(resp => {
                            this.loading=false;
                            if(resp.status==200){
                                var tdJson = localStorage.getItem("trustedDevice");
                                if(tdJson){
                                    tdJson = JSON.parse(tdJson);
                                }else{
                                    tdJson = {};
                                }
                                tdJson[this.Utils.strAESKeyEncrypt(this.dual.email, commonstate.ENCRYPT_KEY)] = td;
                                localStorage.setItem("trustedDevice", JSON.stringify(tdJson));
                                //localStorage.setItem(this.dual.email+"trustedDevice", td);
                                //登录验证
                                this.dualOtp = this.otp;
                                //登录
                                this.resumeLoginAfterDualVerify();
                            }else{

                            }
                        });   
                    }else{
                        this.dualOtp = this.otp;
                        //登录验证
                        //登录
                        this.resumeLoginAfterDualVerify();
                    }
                    this.loading=false;
                }else if(res.reason == "verificationCodeExpired"){
                    this.loading=false;
                    this.$toast({
                        text: this.$t('language.popup.verifyPopup.exception.verificationCodeExpired'),
                        type: "notice",
                        idValue: "verify"
                    });
                }else if(res.reason == "verificationCodeError"){
                    this.loading=false;
                    this.$toast({
                        text: this.$t('language.popup.verifyPopup.exception.verificationCodeError'),
                        type: "notice",
                        idValue: "verify"
                    });
                }else{
                    this.loading=false;
                }
            })
        },
        //选择验证方式
        onChangeOption(){
            this.selectOption = Object.assign([], this.selectOptionAll);
            this.$refs.cloudSelect.$refs.sel.style.width =400+'Px';
            switch (this.choiceVerify) {
                case 'email':   
                    this.selectOption.splice(1, 1);
                    this.choiceVerify="phone";
                    break;
                case 'phone':
                    this.selectOption.splice(0, 1);
                    this.choiceVerify="email";
                    break;  
            }
        },
        //验证RecoveryCode，进入选择验证方式页面
        verificationRecoveryCode(){
            if(this.verifyRecoveryCode){
                // var data = {
                //     userId: this.dualUd,
                //     recoverCode: this.verifyRecoveryCode,
                // }
                // this.Utils.doDualVerifyAesRequest("verify_recover", data).then(res => {
                    if(this.dual.recoverCode==this.verifyRecoveryCode){
                        this.state = "recovery-change";
                        this.choiceVerify = "email";
                    }else{
                        this.$toast({
                            text: this.$t('language.popup.verifyPopup.exception.verificationRecoveryCodeExpired'),
                            type: "notice",
                            idValue: "verify"
                        });
                    }
                // })
            }
        },
        cancelVerify(){
            //验证是否是可信任设备，可信任设备直接取消流程
            if(this.dual.trustedDeviceGroup){
                var devices = this.dual.trustedDeviceGroup;
                var isTrust = false;
                var tdJson = localStorage.getItem("trustedDevice");
                if(tdJson){
                    var td = commonUtils.getTrustedDeviceByEmail(this.dual.email);
                    for(var i=0;i<devices.length;i++){
                        if(td&&td==devices[i]){
                            isTrust = true;
                        }
                    }
                }
                if(isTrust){
                    this.closePending();
                }else{
                    this.recoveryPending=true;
                    this.state='verify';
                }
            }else{
                this.recoveryPending=true;
                this.state='verify';
            }
        },
        //进入pending状态
        changeRecoveryState(data){
            //修改状态
            // else if(result.reason == "verificationCodeExpired"){
            //     $.showTip($elem.find("[name='code']"), "The verification code has expired.", 'error');
            // }else if(result.reason == "verificationCodeError"){
            //     $.showTip($elem.find("[name='code']"), "The verification code is incorrect, please check the code and try again.", 'error');
            // }
            this.loading=true;
            this.Utils.doDualVerifyAesRequest("open_pending", data).then(res => {
                this.loading=false;
                if(res.status==200&&res.message=="success"){
                    //发送邮件
                    this.Utils.doDualVerifyAesRequest("send_pending", {userId: this.dualUd,redirectUrl:commonstate.nowNewUrl}).then(response => {
                    })
                    this.state = "recovery-success";
                }
            })
            
        },
        closePending(){
            this.loading=true;
            this.Utils.doDualVerifyAesRequest("close_pending", {userId: this.dualUd}).then(res => {
                this.loading=false;
                if(res.status==200){
                    this.cancelVerifySuccess();
                }
            })
        },
        //取消pending成功
        cancelVerifySuccess(){
            this.loading=true;
            this.Utils.doDualVerifyAesRequest("recover", {userId: this.dualUd}).then(res => {
                this.loading=false;
                if(res.status==200){
                    this.newRecoveryCode = res.recoverCode;
                    this.state = "recovery-cancel";
                }
            })
        },
        showOtherOptions(index){
             //删除某一项的下标
           	if (this.deleteOption && this.deleteOption.length > 0) {
					this.selectPhoneOption.splice(this.deleteOption[0].id, 0, {
						id: this.deleteOption[0].id,
						name: this.deleteOption[0].name
					});
					if (this.deleteOption[0].id <= index) {
						this.deleteOption = this.selectPhoneOption.splice(index + 1, 1);
					} else {
						this.deleteOption = this.selectPhoneOption.splice(index, 1);
					}
				} else {
					this.selectPhoneOption.splice(0, 0, {
						id: 0,
						name: this.selectPhoneValue,
                        value: this.cornet
					});
					this.deleteOption = this.selectPhoneOption.splice(index + 1, 1);
				}
				this.$forceUpdate();
        },
        onChangePhoneOption(newValue){
            let cornet = newValue.split("+")[1];
            this.cornet=cornet.split(')')[0];
           // console.log('新的区号'+this.cornet);
        },
        //生成uuid
        generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        },
        //时间戳转化
        format(date) {
            //shijianchuo是整数，否则要parseInt转换
            var time = new Date(date);
            var y = time.getFullYear();
            var m = time.getMonth()+1;
            var d = time.getDate();
            return d+'/'+m+'/'+y;
        },
        checkShowPassword(){
            this.showPassword = !this.showPassword;
            if(this.showPassword){
                this.$refs.passwordLogin.type = "text";
            }else{
                this.$refs.passwordLogin.type = "password";
            }
        },
    }
};
</script>

<style scoped>
#signInPopup {
    border-radius: 10px;/*no*/
}

#signInPopup.content{
    border: 0px solid #ffffff;
}

.turnstile-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

#signInPopup .login-body {
    width: calc(100% - 60px);/*no*/
    padding: 0px 30px 20px 30px;/*no*/
    margin-top: 10px;
    /*no*/
}

.sign-line {
    width: 100%;
    height: 50px;
    /*no*/
    }

.sign-input {
    float: left;
}

.sign-info {
    float: left;
    line-height: 50px;
    /*no*/
    margin-right: 15px;
    /*no*/
    width: 60px;
    /*no*/
}

.sign-line-one {
    float: left;
    position: relative;
    top: 20px;
    /*no*/
    border-top: 1px solid #cdcdcd;
    /*no*/
}

.sign-line-bottom {
    color: #616161;
    font-size: 14px;
    /*no*/
    float: left;
    line-height: 20px;
    /*no*/
    margin-top: 10px;
    /*no*/
}
    
.signInInfo {
    width: 400px;
    /*no*/
    border-radius: 5px;
    /*no*/
    text-indent: 20px;/*no*/
}

.remember-me {
    font-size: 16px;
    /*no*/
    color: #616161;
    float: left;
}

.forget-pass {
    float: right;
    cursor: pointer;
    font-size: 14px;/*no*/
    color: #BDBDBD;
}

.login-sure {
    height: 30px;
    /*no*/
    margin-top: 10px;
    /*no*/
    float:left;
    width: 36%;
}

.login {
    width: 85%;
    float: left;
}
    
.login-with {
    text-align: right;
    color: #737373;
    font-size: 14px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
    top: 10px;
    /*no*/
    float: right;
}

.eac-input-wrap {
    width: 190px;
    /*no*/
    border-radius: 5px;
    /*no*/
    text-indent: 20px;/*no*/
    height: 38px;
    /*no*/
}
.login-facebook {
    position: relative;
    background-position-x: -18px;
    /*no*/
    width: 30px;
    /*no*/
    height: 30px;
    /*no*/
    margin-top: 0;
    background-image: url("~@/assets/images/workspace/sns.png");
    background-repeat: no-repeat;
    background-position-y: 0;
    background-position-y: -70px;
    /*no*/
    -ms-background-position-y: -15px;
    /*no*/
    cursor: pointer;
    float: right;
    top: 15px;
    /*no*/
    margin-left: 5px;
    /*no*/ 
}

 .login-google {
    position: relative;
    background-position-x: -240px;
    /*no*/
    width: 30px;
    /*no*/
    height: 30px;
    /*no*/
    margin-top: 0;
    background-image: url("~@/assets/images/workspace/sns.png");
    background-repeat: no-repeat;
    background-position-y: -70px;
    /*no*/
    -ms-background-position-y: -15px;
    /*no*/
    cursor: pointer;
    float: right;
    top: 15px;
    /*no*/
    margin-left: 5px;
    /*no*/
}

.sign-up-black {
    position: relative;
    display: inline-block;
    background-image: url("~@/assets/images/workspace/icon_util.png");
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: 73px -160px;
    /*no*/
    top: 5px;
    /*no*/
}



.sign-line-signUp {
    float: left;
    text-align: right;
    color: #5166BD;
    font-size: 14px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
    top: 10px;
    /*no*/
}

.sign-line-signUp:hover {
    cursor: pointer;
}

.signInInfo-email {
    background-image: url("~@/assets/images/workspace/icon_util.png");
    background-position: 589px 57px;/*no*/
    background-origin: content-box;
    position:absolute;
    margin-left: 7px;/*no*/
    top: 85px;/*no*/
    width: 20px;/*no*/
    height: 20px;/*no*/
}

.signInInfo-password {
    background-image: url("~@/assets/images/workspace/icon_util.png");
    background-position: 556px 57px;/*no*/
    background-origin: content-box;
    position:absolute;
    margin-left: 7px;/*no*/
    top: 135px;/*no*/
    width: 20px;/*no*/
    height: 20px;/*no*/
}

.signInInfo-forget {
    background-image: url("~@/assets/images/workspace/icon_util.png");
    background-position: 525px 57px;/*no*/
    background-origin: content-box;
    position:absolute;
    margin-left: 7px;/*no*/
    top: 185px;/*no*/
    width: 20px;/*no*/
    height: 20px;/*no*/
}

.nocheck-small:hover {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -54px -208px;
    /*no*/
    cursor: not-allowed;
    pointer-events: inherit;
    cursor: pointer;
}
.check-small:hover {
    cursor: not-allowed;
    cursor: pointer;
}

.forgot-back {
    float: right;
    color: #4681f1;
    padding-top: 7px;/*no*/
}

.forgot-back:hover {
    cursor: pointer;
}

.forgot-send-email {
    width: 100%;
    float: left;
}

.forgot-sure {
    height: 30px;/*no*/
    margin-top: 10px;/*no*/
}

.forgot-tips {
    font-size: 14px;/*no*/
    text-align: center;
    margin-top: 5px;/*no*/
}

.forgot-tips a{
    text-decoration: none;
}

.forgot-line-one {
    float: left;
    position: relative;
    top: 5px;
    /*no*/
    border-top: 1px solid #cdcdcd;
    /*no*/
}

.forgot-title-tips {
    margin: 10px 0 0 0;/*no*/
    font-size: 14px;/*no*/
}

.forgot-title {
    height:28px;/*no*/
    margin: 0 30px 0 30px;/*no*/
}

</style>



// WEBPACK FOOTER //
// src/components/popup/share_page_popups/sign_in_popup.vue